import HistoricMailsModalInfoView from "./historic_mails-modal_info.html";

import _ from 'lodash';


angular.module("events")
    .controller("EventsHistoricMailsListCtrl", ['event', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'LoginService',
        function (event, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, LoginService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_HISTORIC_WRITE");
            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }
            $scope.event = event;

            $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
            { title: $filter('translate')('events.historic_mails.historic_mails') }
            ];

            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.historic_mails.historic_mails');


            /**
             * Selector de módulo
             */
            var guestTabSelect = [
            {
                name: $filter('translate')('events.historic_mails.programs'), value: "guests/program"
                }, {
                    name: $filter('translate')('events.historic_mails.guests'), value: "guests/invitations"
                }
            ];

            var emailTabSelect = [
            {
                name: $filter('translate')('events.historic_mails.work_team'), value: "work_team/email"
            },
            {
                name: $filter('translate')('events.historic_mails.staff_email'), value: "staff/email"
            },
             {
                 name: $filter('translate')('events.historic_mails.guests'), value: "guests/email"
             }
            ];

            var notificationTabSelect = [{
                name: $filter('translate')('events.historic_mails.event'), value: "event/notify"
            },
            {
                name: $filter('translate')('events.historic_mails.task'), value: "task/notify"
            },
            {
                name: $filter('translate')('events.historic_mails.program_acts'), value: "program_acts/notify"
            },
            {
                name: $filter('translate')('events.historic_mails.material'), value: "material/notify"
            },
            {
                name: $filter('translate')('events.historic_mails.staff_notify'), value: "staff/notify"
            }
            ];

            var inscriptionsTabSelect = [
                {
                    name: $filter('translate')('events.historic_mails.inscriptions_enrolled'), value: "inscriptions/enrolled"
                }, {
                    name: $filter('translate')('events.historic_mails.inscriptions_confirmation'), value: "inscriptions/confirmation"
                },{
                    name: $filter('translate')('events.historic_mails.inscriptions_rejected'), value: "inscriptions/rejected"
                }
            ];

            $scope.selectModules = guestTabSelect;


            $scope.search = { module: "guests/invitations" };

            var actualTab = 0;

            $scope.changeTab = function (tab) {
                if (actualTab != tab) {
                    if (tab == 0) {
                        $scope.selectModules = guestTabSelect;
                    } else if (tab == 1) {
                        $scope.selectModules = emailTabSelect;
                    } else if (tab == 2) {
                        $scope.selectModules = notificationTabSelect;
                    }
                    else {
                        $scope.selectModules = inscriptionsTabSelect;
                    }
                    $scope.search.module = undefined;
                    actualTab = tab;
                }
            }

            $scope.gridOptionHistoricMails = {
                pdfTitle: $filter('translate')('events.historic_mails.historic_mails'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                enableSorting: true,
                paginationPageSizes: [20, 50, 100],
                paginationPageSize: 20,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                  {
                      name: 'mail_date', field: 'mail_date', displayName: $filter('translate')('events.historic_mails.mail_date'),
                      enableFiltering: false, enableHiding: true, cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\''
                  },
                  { name: 'subject', field: 'subject', displayName: $filter('translate')('events.historic_mails.subject'), enableFiltering: true, enableSorting: false, enableHiding: true },
                  { name: 'to', field: 'to', displayName: $filter('translate')('events.historic_mails.to'), enableFiltering: true, enableSorting: false, enableHiding: true
                  },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: "", action: 'ng-click="grid.appScope.infoModal(row.entity.id)"', cssIconClass: "fa fa-info margin-left-5"
                      },
                          { title: "", action: 'ui-sref="{{row.entity.link}}" ng-if="row.entity.link != null"', cssIconClass: "fa fa-link" },
                      ], { cssClass: "pull-right" })
                  },
                ],
                getData: function (options) {
                    angular.forEach($scope.search, function (value, key) {
                        options[key] = value;
                    });
                    options.event_id = $stateParams.id;
                    return Restangular.all('HistoricMails').getList(options);
                }
            };

            $scope.makeSearch = function () {
                $scope.gridOptionHistoricMails.loadData(false);
            }

            /**
             * Abre el modal con la información del mail.
             */
            $scope.infoModal = function (id) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: HistoricMailsModalInfoView,
                    size: "lg",
                    controller: "HistoricMailModalCtrl",
                    resolve: {
                        options: function () {
                            return { id: id, type: actualTab };
                        }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function () {
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });
            }


        }])

.controller("HistoricMailModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'options', function ($scope, $uibModalInstance, Restangular, options) {

    $scope.mail = {};
    $scope.downloadUrl = [];
    $scope.showAttachments = 0;

    Restangular.one("HistoricMails/HistoricMailsNotifications").get({ id: options.id }).then(function (mail) {
        $scope.mail = mail;
        _.each($scope.mail.FK_historic_mails_attachments_historic_mails, function (attachment) {
            attachment.downloadUrl = (window as any).CONFIG.api_url + 'HistoricMails/getFile?uid=' + attachment.uid + '&filename=' + attachment.name
            $scope.showAttachments = 1;
        });
    });

    $scope.downloadFile = function (attachment) {
        window.open(attachment.downloadUrl, '_blank', '');
    }

    $scope.downloadFiles = function () {
        _.each($scope.mail.FK_historic_mails_attachments_historic_mails, function (attachment) {
            window.open(attachment.downloadUrl, '_blank', '');
        });
    }

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}])

;
